'use client';

import { ArrowLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';
import Button from '@/ui/Button';
import AdsterraBanner from '@/components/AdsterraBanner';

export default function PrivacyPage() {
  const router = useRouter();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Button
          variant="ghost"
          onClick={() => router.back()}
          className="mb-8 flex items-center gap-2"
        >
          <ArrowLeft size={20} />
          Back
        </Button>

        <div className="mb-12">
          <h1 className="text-5xl sm:text-6xl font-bold text-foreground mb-4">
            Privacy Policy
          </h1>
          <p className="text-muted">
            Last updated: November 2024
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <AdsterraBanner position="top" />

        <div className="bg-card-bg border border-border rounded-2xl p-8 sm:p-12
          space-y-8">
          {/* Section 1 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              1. Our Privacy Commitment
            </h2>
            <p className="text-foreground/80 leading-relaxed">
              Minifictionverse does not collect, store, or process any personal
              information from users. You can browse and read stories completely
              anonymously without providing any personal data.
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              2. What We Do Not Collect
            </h2>
            <ul className="list-disc list-inside space-y-2 text-foreground/80">
              <li>Names, email addresses, or phone numbers</li>
              <li>Reading history or preferences</li>
              <li>Cookies for user tracking</li>
              <li>IP addresses for identification</li>
              <li>Account information or user profiles</li>
              <li>Any personal identifying information</li>
            </ul>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              3. Security
            </h2>
            <ul className="list-disc list-inside space-y-2 text-foreground/80">
              <li>All data transmitted via HTTPS encryption</li>
              <li>Secure server infrastructure with regular updates</li>
              <li>Story content protected against unauthorized access</li>
              <li>No personal data means no data breach risk</li>
            </ul>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              4. Compliance
            </h2>
            <ul className="list-disc list-inside space-y-2 text-foreground/80">
              <li>GDPR compliant - no personal data processing</li>
              <li>CCPA compliant - no user data collection</li>
              <li>Safe for all ages - no age verification needed</li>
              <li>No data sharing with third parties</li>
            </ul>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              5. Contact
            </h2>
            <p className="text-foreground/80 leading-relaxed mb-4">
              For privacy questions or concerns:
            </p>
            <div className="p-4 bg-background rounded-lg">
              <p className="text-foreground/70">
                Email: helpdesk@minifanfictionverse.site
              </p>
            </div>
          </section>
        </div>

        <AdsterraBanner position="bottom" />
      </div>
    </div>
  );
}
